<div class="container">

  <div class="col-lg-12 order-lg-2 col-md-12 mb-md-4 order-md-2 col-sm-12 mb-sm-4 order-sm-1 col-12 order-xs-1">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div
        [ngClass]="isMobile() ? 'login animate__animated animate__fadeInDown' : 'login animate__animated animate__fadeInRight'">
        <div class="caja mat-elevation-z8">

          <div class="row">
            <div class="col-md-12">
              <div id="loginForm_server_validation" class="alert alert-danger" style="display: none"></div>
            </div>
          </div>

          <div class="bienvenido lead2">

            <p>
              {{Etiquetas.LeadText3}}
            </p>
          </div>
          <div class="bienvenido">

            <p>
              {{Etiquetas.LeadText4}}
            </p>
          </div>
          <div class="formulario-login">

            <mat-form-field color="accent-darker" color="primary-darker" 
              appearance="outline">
              <mat-label>{{Etiquetas.ClaveActual}}</mat-label>
              <input placeholder="Ingresá tu clave actual" [type]="hide1 ? 'password' : 'text'" matInput
                formControlName="CurrentPassword">

              <button type="button" (click)="hide1 = !hide1" mat-icon-button matSuffix color="primary-darker">
                <mat-icon color="accent-darker">{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>

              <mat-error *ngIf="!currentPassword.valid && currentPassword.touched">
                {{ Validaciones.EscribirClave }}
              </mat-error>
            </mat-form-field>

            <mat-form-field color="accent-darker"  appearance="outline">
              <mat-label>{{Etiquetas.ClaveNueva}}</mat-label>
              <input placeholder="Ingresá una nueva clave para tu cuenta" [(ngModel)]="value1"
                (ngModelChange)="setCheckboxes()" [type]="hide2 ? 'password' : 'text'" matInput
                formControlName="NewPassword">

              <button type="button" (click)="hide2 = !hide2" mat-icon-button matSuffix color="primary-darker">
                <mat-icon color="accent-darker">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-hint>{{Validaciones.ValidacionClaveNueva1}}</mat-hint>


              <mat-error *ngIf="!newPassword.valid && newPassword.touched">
                Ingresá una clave nueva válida
              </mat-error>

            </mat-form-field>


            <div class="row checkboxes-validacion-nueva-clave">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                <mat-checkbox style="cursor:default !important" [disableRipple]="true" (click)="$event.preventDefault()"
                  [checked]="nuevaClaveMayusculas" class="cell" color="accent">
                  {{Validaciones.ValidacionClaveNueva2}}
                </mat-checkbox>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                <mat-checkbox style="cursor:default !important" [disableRipple]="true" (click)="$event.preventDefault()"
                  [checked]="nuevaClaveMinusculas" class="cell" color="accent">
                  {{Validaciones.ValidacionClaveNueva3}}
                </mat-checkbox>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                <mat-checkbox style="cursor:default !important" [disableRipple]="true" (click)="$event.preventDefault()"
                  [checked]="nuevaClaveCaracteresEspeciales" class="cell" color="accent">
                  {{Validaciones.ValidacionClaveNueva4}}
                </mat-checkbox>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                <mat-checkbox style="cursor:default !important" [disableRipple]="true" (click)="$event.preventDefault()"
                  [checked]="nuevaClaveNumeros" class="cell" color="accent">
                  {{Validaciones.ValidacionClaveNueva5}}
                </mat-checkbox>
              </div>

            </div>


            <mat-form-field color="accent-darker" color="primary-darker" 
              appearance="outline">
              <mat-label>{{Etiquetas.RepetirClaveNueva}}</mat-label>
              <input placeholder="Volvé a ingresar tu nueva clave" [type]="hide3 ? 'password' : 'text'" matInput
                formControlName="NewPasswordConfirmed">

              <button type="button" (click)="hide3 = !hide3" mat-icon-button matSuffix color="primary-darker">
                <mat-icon color="accent-darker">{{hide3 ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>

              <mat-error *ngIf="!newPasswordConfirmed.valid && newPasswordConfirmed.touched">
                {{ Validaciones.ConfirmacionClaveNueva }}
              </mat-error>
            </mat-form-field>



          </div>

          <div class="d-flex justify-content-center align-items-center mb-5">

            <button style="width: 50%;" mat-flat-button color="accent-darker" [disabled]="form.invalid"
              tabindex="-1" type="submit">{{Etiquetas.Boton}}</button>

          </div>

          <div class="d-flex justify-content-center align-items-center pie-caja">

            <a class="hyperlink-pie-caja" href="mailto:{{Etiquetas.MailContacto}}">
              {{Etiquetas.Ayuda}}</a>

          </div>
        </div>
      </div>
    </form>
  </div>

</div>

<!-- <section id="hero" class="d-flex align-items-center justify-content-center cambiar-clave-div">
  <div class="container">

    <div class="spacer-top">
     
    </div>
    <div class="row align-items-center justify-content-evenly">
      <div class="col-lg-6 pt-4 pt-lg-0 order-lg-1 order-sm-2 order-xs-2 content"
        [ngClass]="isMobile() ? 'login animate__animated animate__fadeInUp' : 'login animate__animated animate__fadeInLeft'">

        <h4 style="margin-top:3%">{{Etiquetas.LeadText1}}</h4>

        <h1>{{Etiquetas.LeadText2}}</h1>
        <h1 class="lead-bars"> //////////</h1>

      </div>
      <div class="col-lg-6 order-lg-2 col-md-12 mb-md-4 order-md-2 col-sm-12 mb-sm-4 order-sm-1 col-12 order-xs-1">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">

          <div
            [ngClass]="isMobile() ? 'login animate__animated animate__fadeInDown' : 'login animate__animated animate__fadeInRight'">
            <div class="caja mat-elevation-z8">

              <div class="row">
                <div class="col-md-12">
                  <div id="loginForm_server_validation" class="alert alert-danger" style="display: none"></div>
                </div>
              </div>

              <div class="bienvenido lead2">

                <p>
                  {{Etiquetas.LeadText3}}
                </p>
              </div>
              <div class="bienvenido">

              <p>
                {{Etiquetas.LeadText4}}
              </p>
              </div>
              <div class="formulario-login">

                <mat-form-field color="accent-darker" color="primary-darker" 
                  appearance="outline">
                  <mat-label>{{Etiquetas.ClaveActual}}</mat-label>
                  <input placeholder="Ingresá tu clave actual" [type]="hide1 ? 'password' : 'text'" matInput
                    formControlName="CurrentPassword">

                  <button type="button" (click)="hide1 = !hide1" mat-icon-button matSuffix color="primary-darker">
                    <mat-icon color="accent-darker">{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>

                  <mat-error *ngIf="!currentPassword.valid && currentPassword.touched">
                    {{ Validaciones.EscribirClave }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field color="accent-darker"  appearance="outline">
                  <mat-label>{{Etiquetas.ClaveNueva}}</mat-label>
                  <input placeholder="Ingresá una nueva clave para tu cuenta" [(ngModel)]="value1"
                    (ngModelChange)="setCheckboxes()" [type]="hide2 ? 'password' : 'text'" matInput
                    formControlName="NewPassword">

                  <button type="button" (click)="hide2 = !hide2" mat-icon-button matSuffix color="primary-darker">
                    <mat-icon color="accent-darker">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  <mat-hint>{{Validaciones.ValidacionClaveNueva1}}</mat-hint>


                  <mat-error *ngIf="!newPassword.valid && newPassword.touched">
                    Ingresá una clave nueva válida
                  </mat-error>

                </mat-form-field>


                <div class="row checkboxes-validacion-nueva-clave">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox style="cursor:default !important" [disableRipple]="true"
                      (click)="$event.preventDefault()" [checked]="nuevaClaveMayusculas" class="cell"
                      color="accent">
                      {{Validaciones.ValidacionClaveNueva2}}
                    </mat-checkbox>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox style="cursor:default !important" [disableRipple]="true"
                      (click)="$event.preventDefault()" [checked]="nuevaClaveMinusculas" class="cell"
                      color="accent">
                      {{Validaciones.ValidacionClaveNueva3}}
                    </mat-checkbox>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox style="cursor:default !important" [disableRipple]="true"
                      (click)="$event.preventDefault()" [checked]="nuevaClaveCaracteresEspeciales" class="cell"
                      color="accent">
                      {{Validaciones.ValidacionClaveNueva4}}
                    </mat-checkbox>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox style="cursor:default !important" [disableRipple]="true"
                      (click)="$event.preventDefault()" [checked]="nuevaClaveNumeros" class="cell"
                      color="accent">
                      {{Validaciones.ValidacionClaveNueva5}}
                    </mat-checkbox>
                  </div>

                </div>


                <mat-form-field color="accent-darker" color="primary-darker" 
                  appearance="outline">
                  <mat-label>{{Etiquetas.RepetirClaveNueva}}</mat-label>
                  <input placeholder="Volvé a ingresar tu nueva clave" [type]="hide3 ? 'password' : 'text'" matInput
                    formControlName="NewPasswordConfirmed">

                  <button type="button" (click)="hide3 = !hide3" mat-icon-button matSuffix color="primary-darker">
                    <mat-icon color="accent-darker">{{hide3 ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>

                  <mat-error *ngIf="!newPasswordConfirmed.valid && newPasswordConfirmed.touched">
                    {{ Validaciones.ConfirmacionClaveNueva }}
                  </mat-error>
                </mat-form-field>



              </div>

              <div class="d-flex justify-content-center align-items-center mb-5">

                <button style="width: 50%;" mat-flat-button color="accent-darker" [disabled]="form.invalid"
                  tabindex="-1" type="submit">{{Etiquetas.Boton}}</button>

              </div>

              <div class="d-flex justify-content-center align-items-center pie-caja">

                <a class="hyperlink-pie-caja" href="mailto:{{Etiquetas.MailContacto}}">
                  {{Etiquetas.Ayuda}}</a>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="spacer-bottom">
    

    </div>


  </div>
</section> -->